<template>
    <Banner v-if="block.type" :block="block"></Banner>
    <Slider v-else :block="block"></Slider>
</template>
<script>
import Slider from "./Slider.vue";
import Banner from "./Banner.vue";
export default {
    name: "ProductBlock",
    components: { Banner, Slider },
    props: {
        block: {
            type: Object,
            required: true,
        },
    },
};
</script>
<style></style>
